import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconPause = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M14.7,31.3h-9V4.7h9V31.3z M7.4,29.6H13V6.4H7.4V29.6z"/>
        <path d="M30.3,31.3h-9V4.7h9V31.3z M23,29.6h5.5V6.4H23V29.6z"/>
      </g>
    </SvgIcon>
  );
};

IconPause.displayName = 'IconPause';
IconPause.muiName = 'SvgIcon';

export default IconPause;



// WEBPACK FOOTER //
// ./src/components/Icons/IconPause.js